/* Lieferzeit */
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const qty = window.variantInventories[variant.id];
  const deliveryTimes = window.variantDeliveryTimes;
  const isPreorderable = window.isProductPreorderable;
  const outOfStockTime = isPreorderable ? "Vorbestellung innerhalb DE möglich!" : deliveryTimes.default.out_of_stock;
  const inStockTime = deliveryTimes.custom.in_stock || deliveryTimes.default.in_stock;
  const infoElement = document.getElementById('lieferzeit-info');

  if (infoElement) {
    if (qty <= 0) {
      infoElement.innerHTML = `<strong>Auf Lager</strong> ${outOfStockTime}`;
    } else {
      infoElement.innerHTML = `<strong>Auf Lager</strong> ${inStockTime}`;
    }
  }
});

/* Mehr Anzeigen Mobile */
document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  if (!isMobile) return;

  const section = document.getElementById('product-description');
  if (!section) return;

  const button = document.createElement('button');
  button.textContent = 'Mehr anzeigen';
  button.style.display = 'block';
  button.style.marginTop = '1rem';
  button.style.background = '#ee794f';
  button.style.color = '#ffffff';
  button.style.border = 'none';
  button.style.padding = '10px';
  button.style.cursor = 'pointer';

  button.addEventListener('click', () => {
    section.classList.toggle('expanded');
    button.textContent = section.classList.contains('expanded') ? 'Weniger anzeigen' : 'Mehr anzeigen';
  });

  section.after(button);
});

document.addEventListener("DOMContentLoaded", () => {
  const init = () => {
    const cartDrawer = document.querySelector(".cart-drawer");

    if (!cartDrawer) {
      // Wenn der Drawer noch nicht da ist, alle 1000ms checken (max. 3s)
      const interval = setInterval(() => {
        const cartDrawerCheck = document.querySelector(".cart-drawer");
        if (cartDrawerCheck) {
          clearInterval(interval);
          callbackWithDrawer(cartDrawerCheck);
        }
      }, 1000); // alle 300ms checken, ob CartDrawer jetzt da ist.

      setTimeout(() => clearInterval(interval), 2000); // Nach 10 Sekunden / 1000ms abbrechen.
      return;
    }

    callbackWithDrawer(cartDrawer);
  };
  init();
});

function callbackWithDrawer(cartDrawer) {

  const gclid = new URLSearchParams(window.location.search).get("gclid");
  const wbraid = new URLSearchParams(window.location.search).get("wbraid");
  const gbraid = new URLSearchParams(window.location.search).get("gbraid");

  if (gclid || wbraid || gbraid) {
    localStorage.setItem("ref", window.location.href); // href, statt das gesamte Location Objekt.
  }

  if (gclid) {
    localStorage.setItem("refgid", gclid);
  }

  if (wbraid) {
    localStorage.setItem("refwbid", wbraid);
  }

  if (gbraid) {
    localStorage.setItem("refgbid", gbraid);
  }  
  
  const storedGclid = localStorage.getItem("ref");
  const storedGid = localStorage.getItem("refgid");
  const storedGbid = localStorage.getItem("refgbid");
  const storedWbid = localStorage.getItem("refwbid");
  const storedConsent = localStorage.getItem("refConsent");

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const refConsNode = document.getElementById("refcons");
        if (storedConsent && refConsNode) {
          refConsNode.value = storedConsent;
        } else {
          refConsNode.value = "deny";
        }

        const refGidNode = document.getElementById("refgid");
        if (storedGid && refGidNode) {
          refGidNode.value = storedGid;
        }

        const refGbidNode = document.getElementById("refgbid");
        if (storedGbid && refGbidNode) {
          refGbidNode.value = storedGbid;
        }

        const refWbidNode = document.getElementById("refwbid");
        if (storedWbid && refWbidNode) {
          refWbidNode.value = storedWbid;
        }

        const refIdNode = document.getElementById("refid");
        if (storedGclid && refIdNode) {
          //if(storedConsent === 'allow'){
          //  refIdNode.value = 'consent';
          //}
          //else{
          refIdNode.value = storedGclid;
          //}
        }
      }
    }
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}
